/// <amd-module name="Artifacts/Upack/commands/Restore" />
import { getRestoreCommandCreator } from "Artifacts/Root/protocols/Commands";
import { UpackActions } from "Artifacts/Upack/redux";

export const createRestoreCommand = getRestoreCommandCreator(UpackActions.restore);
